import Skeleton from '@material-ui/lab/Skeleton'
import clsx from 'clsx'
import LiveBadge from 'pages/Unauthenticated/Drops/List/DropItem/LiveBadge'
import useStyles from './DropImage.style'
import { DropImageProps } from './DropImage.types'
import ZoomableImage from 'components/ZoomableImage/ZoomableImage'

const DropImage: React.FC<DropImageProps> = ({
  src,
  live = false,
  figureClass,
  imageClass,
  dark = false,
  type = 'square',
  zoomable = false,
}) => {
  const keepProportions = true;

  const {
    figure,
    skeleton,
    darkSkeleton,
    liveBadge,
    imageOriginalProportion,
  } = useStyles({
    keepProportions,
  })

  return (
    <figure className={clsx(figure, figureClass)}>
      {live && <LiveBadge className={liveBadge} />}
      {src ? (zoomable ? (
        <ZoomableImage src={src} className={imageOriginalProportion} />
      ) : (
        <img src={src} className={imageOriginalProportion} />
      )) : (
        <Skeleton
          variant='rect'
          className={clsx(
            skeleton,
            dark ? darkSkeleton : undefined,
            imageClass
          )}>
          {type === 'square' && <svg viewBox='0 0 1 1'></svg>}
          {type === 'vertical' && (
            <svg display='block' viewBox='0 0 1 1.475'></svg>
          )}
        </Skeleton>
      )}
    </figure>
  )
}

export default DropImage
